import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import configService from "../../services/config";
import {datadogRum} from "@datadog/browser-rum";

export const fingerprint = async () => {
  try {
    const fingerprintConfig = configService.getItem("fingerprintjs");
    const fpLoad = await FingerprintJS.load({token: fingerprintConfig.token, endpoint: fingerprintConfig.endpoint});
    return await fpLoad.get();
  } catch (e) {
    datadogRum.addUserAction('create fingerprint instance error', {
      event: {
        error: e,
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/fingerprints/fingerprint.js